module.exports = __webpack_public_path__ + "img/quote-matthew-perkins.eff157f0.png";